/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(28);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_NUMBER_OF_DAYS = exports.SET_VEHICLE_VIEWS = void 0;
var SET_VEHICLE_VIEWS = 'SET_VEHICLE_VIEWS';
exports.SET_VEHICLE_VIEWS = SET_VEHICLE_VIEWS;
var SET_NUMBER_OF_DAYS = 'SET_NUMBER_OF_DAYS';
exports.SET_NUMBER_OF_DAYS = SET_NUMBER_OF_DAYS;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(29);

var _reactHotLoader = __webpack_require__(21);

var _Widget = _interopRequireDefault(__webpack_require__(7));

var _store = __webpack_require__(19);

var _widgetComponents = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React render bound to the redux store
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		OSIRIS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC.OSIRIS || !window.DDC.OSIRIS.state || !window.DDC.OSIRIS.state[widgetName]) {
    return {};
  }

  return window.DDC.OSIRIS.state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-vehicle-views');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId);
  });
};

if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Main = function Main(props) {
  var vehicleViews = props.vehicleViews,
      numberOfDays = props.numberOfDays;
  return _react.default.createElement(_common.Common, {
    render: function render(_ref) {
      var labels = _ref.labels,
          prefs = _ref.prefs;
      var disclaimerAttributes = prefs.disclaimerLabel ? {
        'data-toggle': 'popover',
        'data-placement': 'bottom',
        'data-content': "".concat(labels.get(prefs.disclaimerLabel))
      } : {};
      var daysAlias = numberOfDays === 1 ? 'DAY' : 'DAYS';
      return _react.default.createElement("div", _extends({
        className: "alert alert-info w-auto d-inline-block py-1 px-3 my-3 mt-sm-4 mb-sm-0 ddc-font-size-small"
      }, disclaimerAttributes), _react.default.createElement("i", {
        className: "ddc-icon ddc-icon-".concat(prefs.icon, " ddc-icon-size-").concat(prefs.iconSize, " mr-3")
      }), _react.default.createElement("div", {
        className: "float-right mt-2"
      }, _react.default.createElement("span", null, vehicleViews, " "), _react.default.createElement("span", null, labels.get('VIEWS_IN_THE_PAST'), " "), _react.default.createElement("span", null, numberOfDays, " "), _react.default.createElement("span", null, labels.get(daysAlias), " ")));
    }
  });
};

Main.propTypes = {
  vehicleViews: _propTypes.default.number.isRequired,
  numberOfDays: _propTypes.default.number.isRequired
};
var _default = Main;
exports.default = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _reactRedux = __webpack_require__(4);

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _Main = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer() {
    _classCallCheck(this, WidgetContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).apply(this, arguments));
  }

  _createClass(WidgetContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          vehicleViews = _this$props.vehicleViews,
          numberOfDays = _this$props.numberOfDays;
      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var prefs = _ref.prefs,
              labels = _ref.labels;

          if (vehicleViews >= prefs.minimumViews) {
            return _react.default.createElement(_Main.default, {
              vehicleViews: vehicleViews,
              numberOfDays: numberOfDays,
              prefs: prefs,
              labels: labels
            });
          }

          return null;
        }
      });
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  vehicleViews: _propTypes.default.number.isRequired,
  numberOfDays: _propTypes.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    vehicleViews: state.vehicleViews,
    numberOfDays: state.numberOfDays
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vehicleViews = _interopRequireDefault(__webpack_require__(11));

var _numberOfDays = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  vehicleViews: _vehicleViews.default,
  numberOfDays: _numberOfDays.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = numberOfDays;

var _types = __webpack_require__(3);

function numberOfDays() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_NUMBER_OF_DAYS:
        {
          return action.payload;
        }
      // no default
    }
  }

  return state;
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = vehicleViews;

var _types = __webpack_require__(3);

function vehicleViews() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_VEHICLE_VIEWS:
        {
          return action.payload;
        }
      // no default
    }
  }

  return state;
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(30);

var _reduxThunk = _interopRequireDefault(__webpack_require__(31));

var _reducers = _interopRequireDefault(__webpack_require__(9));

var _requestData = _interopRequireDefault(__webpack_require__(17));

var _prefs = _interopRequireDefault(__webpack_require__(16));

var _labels = _interopRequireDefault(__webpack_require__(15));

var _sitemap = _interopRequireDefault(__webpack_require__(18));

var _flags = _interopRequireDefault(__webpack_require__(14));

var _middleware = _interopRequireDefault(__webpack_require__(8));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-vehicle-views - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(26),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(4);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(13));

var _Collapse = _interopRequireDefault(__webpack_require__(12));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(24)


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(23);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(25);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(22);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.249d4416bdf56437d2a4.js